import { render, staticRenderFns } from "./AlertEvents.vue?vue&type=template&id=5b6463c2&"
import script from "./AlertEvents.vue?vue&type=script&lang=ts&"
export * from "./AlertEvents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports